(function ($) {
  var $gdpr = $('.gdpr-video');
  var $toggleGdprVideo = $('#toggleGdprVideo');

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var splitCookie = decodedCookie.split(';');

    for (var i = 0; i < splitCookie.length; i++) {
      var splitCookieItem = splitCookie[i].trim();
      if (splitCookieItem.indexOf(name) === 0) {
        return splitCookieItem.substring(name.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    document.cookie = `${cname}=${cvalue}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }

  function deleteVideoCookie() {
    document.cookie = "gdpr-video=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax";
  }

  function activateVideo($gdpr, autoplay) {
    var $gdpr_video = $gdpr.find('.consent-video');
    var videoIframeHtml = $gdpr_video.attr('data-video');

    if (!videoIframeHtml) {
      console.warn("⚠️ Kein data-video-Attribut gefunden!");
      return;
    }

    // Extrahiere die `src`-URL aus dem vorhandenen `<iframe>` (data-video)
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = videoIframeHtml;
    var iframe = tempDiv.querySelector("iframe");

    if (!iframe) {
      console.error("❌ Kein `<iframe>` in data-video gefunden!");
      return;
    }

    var embedUrl = iframe.getAttribute("src");

    if (!embedUrl) {
      console.error("❌ Keine `src`-URL im `<iframe>` gefunden!");
      return;
    }

    // Autoplay aktivieren, wenn erforderlich
    if (autoplay) {
      embedUrl += '&autoplay=1';
    }

    console.log(`🎥 Einfügen von iFrame: ${embedUrl}`);

    // Setze den Iframe mit der korrekten URL ein
    $gdpr_video.html(`<iframe src="${embedUrl}" width="560" height="315" frameborder="0" allowfullscreen></iframe>`);

    // Nachricht entfernen
    $gdpr.find('.consent-message').remove();
  }

  function checkCookie() {
    if (getCookie("gdpr-video")) {
      console.log("🍪 GDPR Cookie gefunden – Videos werden aktiviert.");
      $gdpr.each(function () {
        activateVideo($(this), false);
      });
      $toggleGdprVideo.prop('checked', true);
    } else {
      console.log("❌ Kein GDPR-Cookie – Videos bleiben blockiert.");
      $toggleGdprVideo.prop('checked', false);
    }
  }

  checkCookie();

  $gdpr.on("click", function (event) {
    if ($(event.target).is("button.confirm-gdpr")) {
      activateVideo($(this), true);
      setCookie("gdpr-video", "true", 1);
    }
  });

})(jQuery);